module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8dg4H"))).then(() => parcelRequire('hEqeo'));